import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { MarginProps } from '../../../../../theme/styledProps';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { Tooltip } from '../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { TOOLTIP_TEXT } from './SharingSettings.meta';
import { FormValues } from '../../FirmSettings.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const SharingSettings: React.FC<Props> = ({ formBag, ...rest }) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Client Sharing Settings" />

      <Box display="flex" alignItems="center" mt="24">
        <Toggle {...formBag.register('disableAdviserSuggestions')}>
          Disable the Ability for Advisors to See Suggestions
        </Toggle>

        <Tooltip content={TOOLTIP_TEXT}>
          <Icon className="far fa-info-circle" color="neutral.500" fontSize="small" ml="4" />
        </Tooltip>
      </Box>
    </Box>
  );
};
